export default "__VITE_ASSET__9a1c47ea__"